export default __webpack_public_path__ + "static/media/img_step_hami05.c2fff351.png";